const clarinVarSub2Bold = `
font-family: "ClarinvarVF";
font-variation-settings: "wght" 700,"opsz" 66 ;
`;
const clarinVarSub2Regular = `
font-family: "ClarinvarVF";
font-variation-settings: "wght" 400,"opsz" 66 ;
`;
const clarinVarSub2Medium = `
font-family: "ClarinvarVF";
font-variation-settings: "wght" 500,"opsz" 66 ;
`;
const clarinVarSub2ExtraBold = `
font-family: "ClarinvarVF";
font-variation-settings: "wght" 800,"opsz" 66 ;
`;
const clarinVarSub2Light = `
font-family: "ClarinvarVF";
font-variation-settings: "wght" 300,"opsz" 66 ;
`;
const sansBold = `
font-family: "AdelleSansClarin-VF";
font-variation-settings: "wght" 600 ;
`;
const sansRegular = `
font-family: "AdelleSansClarin-VF";
font-variation-settings: "wght" 200 ;
`;

const sansSemiBold = `
font-family: "AdelleSansClarin-VF";
font-variation-settings: "wght" 300 ;
`;
const sansLight = `
font-family: "AdelleSansClarin-VF";
font-variation-settings: "wght" 30 ;
`;
const vintageSans = `
font-family: "TempoLTStdHeavyCondensed";
`;
const vintageGeorgia = `
font-family: "georgiapro", sans-serif;
font-weight: 400;
font-style: normal;
`;
const vintageGeorgiaBold = `
font-family: "georgiapro", sans-serif;
font-weight: 700;
font-style: normal;
`;

const sansExtraBold = `
font-family: "AdelleSansClarin-VF";
font-variation-settings: "wght" 700 ;
`;

export const Font = {
  clarinVarSub2Bold,
  clarinVarSub2Regular,
  clarinVarSub2ExtraBold,
  clarinVarSub2Light,
  clarinVarSub2Medium,
  sansBold,
  sansRegular,
  sansLight,
  sansSemiBold,
  vintageSans,
  vintageGeorgia,
  vintageGeorgiaBold,
  sansExtraBold,
};
